import {Box} from '@logistics-frontend/blocks'
import React, {useCallback} from 'react'
import Picker from 'react-mobile-picker'

import * as classes from './DateTimePicker.classes'

export type DateTimeState = {
  date: string
  hour: string
  minute: string
}

export type DateTimeSelections = Record<
  string,
  {
    date: Array<string>
    hour: Array<string>
    minute: Array<string>
  }
>

type DateTimeSelectorProps = {
  onChange?: (value: DateTimeState) => void
  selections: DateTimeSelections
  value: DateTimeState
}

export const DateTimePicker = ({onChange, selections, value}: DateTimeSelectorProps): React.ReactElement => {
  const handleChange = useCallback(
    (val: DateTimeState, key: string) => {
      let newState: DateTimeState

      if (key === 'date') {
        const newSelections = selections[val.date]
        newState = {date: val.date, hour: newSelections.hour[0], minute: newSelections.minute[0]}
      } else {
        newState = val
      }

      onChange?.(newState)
    },
    [onChange, selections],
  )

  return (
    <Box flexDirection="column" gap="l">
      <Picker<DateTimeState> className={classes.picker} height={16 * 8} onChange={handleChange} value={value}>
        {Object.keys(selections[value.date]).map(key => {
          const section = selections[value.date]
          return (
            <Picker.Column key={key} name={key}>
              {section[key as keyof typeof section].map(value => (
                <Picker.Item key={value} value={String(value)}>
                  {value}
                </Picker.Item>
              ))}
            </Picker.Column>
          )
        })}
      </Picker>
    </Box>
  )
}
